//import './backgroundVideo';
//import './scrollReveal';

import './checkVersion';
import './dateFlatpickr';
import './pieChart';
import './barChart';
import './lineChart';
import './expand';
import './expandTable';
import './languageSwitch';
